import { camelToKebab, camelToPascal } from '@owner/casing';
import { getCasing } from './casing.js';
export const getLists = (lists, configs) => lists.map(({ collection, name, isPreselectionList, preselectedList, sourceList, primaryRelationship, }) => {
    return {
        collection,
        primaryRelationship: primaryRelationship ?? false,
        preselectedList: preselectedList ?? null,
        sourceList: sourceList ?? null,
        isPreselectionList: isPreselectionList ?? false,
        collectionCasing: getCasing(configs[collection]),
        listCasing: {
            camel: name,
            kebab: camelToKebab(name),
            pascal: camelToPascal(name),
        },
        name,
    };
});
//# sourceMappingURL=lists.js.map